import { FieldValues, Path, PathValue, useController, UseControllerProps } from 'react-hook-form';
import { SingleSelectButtonGroup, type SingleSelectButtonGroupProps } from '@stitch-fix/mode-react';
type OptionInfo<ValueString extends string> = SingleSelectButtonGroupProps<ValueString, {
  value: ValueString;
} & Record<string, unknown>>['options'][number];
interface ControlledSingleSelectButtonGroupProps<TFieldValues extends FieldValues> {
  /**
   * sources:
   *
   * - https://www.chromium.org/developers/design-documents/create-amazing-password-forms/
   * - https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofilling-form-controls%3A-the-autocomplete-attribute
   * - https://www.chromium.org/developers/design-documents/form-styles-that-chromium-understands/
   */
  control: UseControllerProps<TFieldValues>['control'];
  name: Path<TFieldValues>;
  options: OptionInfo<PathValue<TFieldValues, Path<TFieldValues>>>[];
}
export type Option = {
  label: string;
  questionId: string;
  value: boolean;
};

/**
 * This component allows [React Hook Form](https://react-hook-form.com/)
 * to easily communicate with Mode React's [SingleSelectButtonGroup](https://mode-react.daylight.stitchfix.com/?path=/story/components-select-button-group--example)
 */
export const ControlledSingleSelectButtonGroup = <TFieldValues extends FieldValues,>({
  control,
  name,
  options
}: ControlledSingleSelectButtonGroupProps<TFieldValues>) => {
  const {
    field: {
      name: selectFieldName,
      onChange,
      value
    }
  } = useController({
    control,
    name
  });
  return <SingleSelectButtonGroup name={selectFieldName} value={value} spacing="grouped" onChange={onChange} options={options} />;
};